<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			center
			:width="formData.bsid==1?'990px':'600px'"
			:append-to-body='true'
			@close="closeClear"
			:visible.sync="addWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					添加汇报
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="ruleForm">
					<div class="form_left">
						<div>
							<el-form-item label="汇报标题" prop="title">
								<el-input v-model="formData.title"  placeholder="输入标题"></el-input>
							</el-form-item>
							<el-form-item label="汇报时间" prop="day">
								<el-date-picker
									v-model="formData.day"
									type="date"
									value-format="yyyy-MM-dd"
									placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="文件格式" prop="ment_url">
								<div class="file_type">
									<div 
										:class="formData.bsid==1?'selectType':''" 
										@click="formData.bsid = 1;formData.ment_url = [];fileList = []">选择图片</div>
									<div 
										:class="formData.bsid==2?'selectType':''" 
										@click="formData.bsid = 2;formData.ment_url = []">选择文件</div>
								</div>
							</el-form-item>
							<el-form-item label="上传文件"  v-if="formData.bsid == 2" prop="">
								<el-upload
									:data="{token:$store.state.user.userinfo.token}"
									class="upload-demo"
									:action="$uploadFile"
									:before-upload="limitFile"
									:on-success="upSuccess"
									:file-list="fileList">
								  <el-button size="small" type="primary">点击上传</el-button>
								  <div slot="tip" class="el-upload__tip">只能上传word/pdf文件，且不超过20M</div>
								</el-upload>
							</el-form-item>
						</div>
					</div>
					<div class="form_right" v-if="formData.bsid == 1">
						<el-upload
							:data="{token:$store.state.user.userinfo.token}"
							:file-list="imgList"
							:action="$uploadImg"
							:before-upload="$limitImg"
							list-type="picture-card"
							:on-remove="handleRemove"
							:on-success="upSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保存</el-button>
				<el-button @click="closeClear">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	import { Message } from 'element-ui'
	import { zzsh } from '@/axios'
	let that;
	export default {
		data(){
			return{
				formData:{
					id:"",
					uid:this.$route.query.uid,
					title:"",
					day:"",
					bsid:1,//1、文件 2、图片
					ment_url:[],
					ment_title:[]
				},
				addWin:false,
				imgList:[],
				dialogImageUrl: '',
				dialogVisible: false,
				fileList:[],
				rules:{
					// 标题
					title:[{ required: true, message: '请输入标题', trigger: 'blur' }],
					// 时间
					day:[{ required: true, message: '请选择时间', trigger: 'blur' }],
					// 选择文件
					ment_url:[{ required: true, message: '请选择文件', trigger: 'blur' }],
				}
			}
		},
		created() {
			that = this;
		},
		props:{
			type:{
				type:String,
				default:'add'
			}
		},
		methods:{
			limitFile(file) {
				var isJPG = file.type === 'application/msword'
						 || file.type === 'application/pdf'
						 || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				var isLt20M = file.size / 1024 / 1024 < 20;
				if (!isJPG) {
					Message.error('请上传系统支持的文件格式');
					return false;
				}
				if (!isLt20M) {
					Message.error('上传文件大小不能超过 20MB!');
					return false;
				}
			},
			submit(){
				// 保存提交
				that.$refs.formData.validate(valid => {
					if(valid){
						that.formData.uid = that.$route.query.uid
						if(that.formData.ment_url.length != 0){
							if(that.type == 'edit'){
								// 编辑
								zzsh.updateThought(that.formData).then(res => {
									if(res.code == 200){
										that.addWin = false;
										that.$emit('dataList')
									}else{
										Message({
											type:"error",
											message:res.msg
										})
									}
								})
							}else{
								// 新增
								zzsh.addThought(that.formData).then(res => {
									if(res.code == 200){
										that.addWin = false;
										that.$emit('dataList')
									}else{
										Message({
											type:"error",
											message:res.msg
										})
									}
								})
							}
						}else{
							Message.warning("请上传文件");
						}
					}
				})
			},
			// 打开替换框
			openEdit(){
				that.addWin = true;
			},
			// 打开替换框
			closeEdit(){
				that.addWin = false;
			},
			// 编辑绑定数据
			bindData(data){
				that.openEdit();
				zzsh.updateThoughtGet({
					id:data.id
				}).then(res => {
					if(res.code == 200){
						for(var key in res.data){
							for(var index in that.formData){
								if(key == index){
									that.formData[index] = res.data[key]
								}
							}
						}
						for(let i=0;i<that.formData.ment_url.length;i++){
							if(res.data.bsid == 1){
								that.imgList.push({
									url:that.formData.ment_url[i],
									name:that.formData.ment_title[i]
								})
							}else{
								that.fileList.push({
									url:that.formData.ment_url[i],
									name:that.formData.ment_title[i]
								})
							}
						}
					}else{
						Message({
							type:"error",
							message:res.msg
						})
					}
				})
			},
			// 上传成功
			upSuccess(res,file){
				if(res.code == 200){
					if(that.formData.bsid == 1){
						that.formData.ment_url.push(res.data.src)
						that.formData.ment_title.push(res.data.title)
					}else{
						// 文件
						that.formData.ment_url = [res.data.src];
						that.formData.ment_title = [res.data.title];
					}
				}else{
					Message({
						type:"error",
						message:"上传失败，请检查网络或文件类型"
					})
				}
			},
			// 九宫格文件移除
			handleRemove(file, fileList) {
				let arr = that.formData.ment_url;
				for(let i=0;i<arr.length;i++){
					if(file.url == arr[i]){
						arr.splice(arr.indexOf(arr[i]),1)
					}
				}
				that.formData.ment_url = arr;
			},
			// 清空数据
			closeClear(){
				that.addWin = false;
				that.formData = {
					id:"",
					uid:this.$route.query.uid,
					title:"",
					day:"",
					bsid:1,//1、文件 2、图片
					ment_url:[],
					ment_title:[]
				};
				that.imgList = [];
				that.fileList = [];
			}
		}
	}
</script>
<style lang="scss" scoped>
	.formData1{
		overflow-y: scroll;
		min-width: 400px;
		.ruleForm{
			display: flex;
			justify-content: space-between;
			.form_left{
				display: flex;
				align-items: center;
				justify-content: center;
				flex: 1;
				height: 330px;
				margin-right: 20px;
				border: 1px solid #ededed;
				padding: 10px 10px;
				box-sizing: border-box;
				.file_type{
					display: flex;
					width: 220px;
					border-radius: 5px;
					border: 1px solid #ededed;
					box-sizing: border-box;
					>div{
						line-height: 36px;
						height: 100%;
						font-size: 14px;
						cursor: pointer;
						width: 50%;
						text-align: center;
					}
					>div:nth-child(2){
						border-top-right-radius: 5px;
						border-bottom-right-radius: 5px;
					}
					>div:nth-child(1){
						border-top-left-radius: 5px;
						border-bottom-left-radius: 5px;
					}
					>div:hover{
						background: #BB0000;
						color: #fff;
					}
					.selectType{
						background: #BB0000;
						color: #fff;
					}
				}
			}
			.form_right{
				overflow-y: scroll;
				width: 490px;
				height: 330px;
				border: 1px solid #ededed;
				padding: 10px 10px;
				box-sizing: border-box;
			}
		}
	}
</style>